import React, { useState, useEffect } from "react";
import { Modal, Input, Button, Typography } from "antd";
import { QuestionCircleOutlined, SendOutlined, CloseCircleOutlined } from '@ant-design/icons';
import HomeColors from "../../../styles/HomeColors";

interface DudaTextoModalProps {
    visible: boolean;
    onClose: () => void;
    onSubmit: (text: string) => void;
    loading?: boolean;
    copypaste?: number;
}

const { Text } = Typography;

const DudaTextoModal: React.FC<DudaTextoModalProps> = ({
                                                           visible,
                                                           onClose,
                                                           onSubmit,
                                                           loading,
                                                            copypaste = 0,
                                                       }) => {
    const [text, setText] = useState("");
    const [valid, setValid] = useState(false);

    useEffect(() => {
        setValid(text.trim().length >= 20);
    }, [text]);

    const handleOk = () => {
        if (valid) {
            onSubmit(text.trim());
            setText("");       // limpiamos campo
            onClose();         // cerramos modal
        }
    };

    return (
        <Modal
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingBottom: '8px' }}>
                    <QuestionCircleOutlined style={{ color: HomeColors.colors.color4, fontSize: '26px' }} />
                    <span style={{ fontSize: '22px', fontWeight: 700, color: '#1f1f1f' }}>Explica el teu dubte</span>
                </div>
            }
            open={visible}
            onCancel={onClose}
            centered
            width={600}
            footer={[
                <Button 
                    key="cancel" 
                    onClick={onClose}
                    icon={<CloseCircleOutlined />}
                    style={{ borderRadius: '8px', fontWeight: 500, padding: '0 20px', height: '40px' }}
                >
                    Cancel·lar
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    loading={loading}
                    onClick={handleOk}
                    disabled={!valid}
                    icon={<SendOutlined />}
                    style={{
                        backgroundColor: valid ? HomeColors.colors.color4 : undefined,
                        borderColor: valid ? HomeColors.colors.color4 : undefined,
                        borderRadius: '8px',
                        fontWeight: 600,
                        padding: '0 24px',
                        height: '40px',
                        boxShadow: valid ? `0 4px 14px ${HomeColors.colors.color4}40` : 'none'
                    }}
                >
                    Enviar Dubte
                </Button>,
            ]}
        >
            <div style={{ marginBottom: '20px', marginTop: '10px' }}>
                <Text type="secondary" style={{ fontSize: '15px' }}>
                    Si us plau, detalla el teu dubte perquè et puguem ajudar de la millor manera possible. Intenta ser clar/a i concís/a.
                </Text>
            </div>

            <Input.TextArea
                rows={6}
                value={text}
                onPaste={(e) => copypaste === 0 && e.preventDefault()}
                onCopy={(e) => copypaste === 0 && e.preventDefault()}
                onCut={(e) => copypaste === 0 && e.preventDefault()}
                onContextMenu={(e) => copypaste === 0 && e.preventDefault()}
                onChange={(e) => setText(e.target.value)}
                placeholder="Ex: Tinc un problema en entendre com funciona la funció X a la línia Y..."
                style={{
                    borderRadius: '12px',
                    padding: '16px',
                    fontSize: '15px',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.02)',
                    borderColor: text.length > 0 && !valid ? '#ff4d4f' : '#d9d9d9',
                    backgroundColor: '#fafafa',
                    transition: 'all 0.3s ease'
                }}
            />

            <div style={{ marginTop: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {!valid ? (
                    <Text type="danger" style={{ fontSize: '13px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                        {text.length > 0 && <><CloseCircleOutlined /> El dubte ha de tenir almenys 20 caràcters.</>}
                    </Text>
                ) : (
                    <Text style={{ fontSize: '13px', color: '#52c41a', display: 'flex', alignItems: 'center', gap: '6px', fontWeight: 500 }}>
                        ✨ Llargada correcta
                    </Text>
                )}
                <Text type="secondary" style={{ fontSize: '13px', fontWeight: 500, color: valid ? '#52c41a' : '#bfbfbf' }}>
                    {text.length} / 20
                </Text>
            </div>
        </Modal>
    );
};

export default DudaTextoModal;
